<mat-icon class="close-icon" (click)="onClose()">close</mat-icon>
<h4 mat-dialog-title>Settings</h4>
<mat-dialog-content>
  <div>
    <p class="pro-description-text">
      ProjectZen Pro enables this account to create unlimited items to
      supercharge your team, along with some other benefits. Learn more
      <a href="gopro" target="_blank">here</a>.
    </p>
    <div class="payment-form-wrapper">
      <form id="paymentForm" action="/charge" method="post">
        <div class="form-row">
          <label for="stripeCredCardElement">Credit or debit card</label>
          @if(!creditCardElement()) {
          <ngx-stripe-card [stripe]="stripe" [options]="cardOptions" [elementsOptions]="elementsOptions"
            (change)="changeCardValues($event)"></ngx-stripe-card>
          }
          @if(creditCardElement()) {
          <div class="">
            <span>{{credCardText()}}</span>
            <button class="change-card" type="button" (click)="changeCredCardLinkHandler()"> change </button>
          </div>
          }
          <span class="cred-card-form-errors" role="alert">
            {{credCardFormErrors()}}
          </span>
        </div>
        <div class="payment-amount-text-wrapper form-row">
          <p>Amount: $7.99/month</p>
        </div>
        @if(expirationNotice().showWrapper) {
        <span class="{{accountService.subscription().proExpiryDate}}">{{expirationNotice().text}}</span>
        }
        @if(proActivationButton().showWrapper) {
        <div class="pro-activation-button-wrapper">
          <button type="button" mat-flat-button [disabled]="proActivationButton().disabled"
            (click)="handleProPaymentFormSubmit()">
            {{proActivationButton().text || 'Upgrade to Pro'}}
          </button>
        </div>
        }
        @if(isDeactivateLinkWrapper()) {
        <div class="deactivate-link-wrapper">
          <button class="change-card" type="button" (click)="deactivateProLinkHandler()">Deactivate</button>
        </div>
        }
        @if(updateCredCardDetailsButton().showWrapper) {
        <div class="update-cred-card-details-button-wrapper">
          <button mat-flat-button [disabled]="updateCredCardDetailsButton().disabled"
            (click)="handleUpdateCardDetailsFormSubmit()">
            Update Credit Card
          </button>
        </div>
        }
        @if(isCancelLinkWrapper()) {
        <div class="cancel-link-wrapper">
          <button class="change-card" type="button" (click)="cancelLinkHandler()">Cancel</button>
        </div>
        }
      </form>
    </div>
    <div class="change-delete-account-container">
      <div class="change-password-settings modal-body">
        <button class="change-password-link" (click)="showChangePasswordDialog()">Change Password</button>
      </div>
      <div class="delete-account-settings modal-body">
        <button class="delete-account-link" (click)="showDeleteAccountDialog()">Delete account</button>
      </div>
    </div>
    <div class="change-dashboard-theme">
      <p>Change Dashboard Theme (for Pro users)</p>
      @for (themeOption of
      dashboardThemeOptions; track $index)
      {
      <button [ngClass]="{'selected' : accountService.otherAccountSettings().dashboardTheme.name === themeOption.name }"
        [disabled]="!accountService.subscription().isProAccount"
        (click)="dashboardThemeSelectAction(themeOption.name)"
        class="first dashboard-theme is-pro-account-{{ accountService.subscription().isProAccount }}">
        <div class="theme-image-wrapper">
          <img class="theme-image" [attr.src]="'/assets/' + themeOption.image" [attr.alt]="themeOption.image" />
        </div>
        <p class="theme-title">{{themeOption.title}}</p>
      </button>
      }
    </div>
  </div>
</mat-dialog-content>